import { Navigate } from 'react-router-dom';

import { NOT_FOUND_PATH } from './constants';

const FallbackRoute = { path: '*', element: <Navigate to={NOT_FOUND_PATH} replace /> };

export default FallbackRoute;
